<template>
    <div>
        <b-row class="my-3">
            <b-col cols="8" class="align-self-center">
                <b-breadcrumb class="m-0 p-0">
                    <b-breadcrumb-item @click="$router.push('/')">
                        Pages
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active>
                        <strong>{{ data.name }}</strong>
                        <b-link :href="'https://www.facebook.com/' + page_id" target="_blank">
                            <font-awesome-icon icon="external-link" />
                        </b-link>
                    </b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col class="align-self-center text-right">
                <b-button variant="outline-secondary" @click="sync" :disabled="(data.batch_sync_customers || []).length > 0">
                    <font-awesome-icon icon="sync" :spin="(data.batch_sync_customers || []).length > 0" />
                    Sync
                </b-button>
            </b-col>
        </b-row>

        <hr/>

        <b-row class="mb-2">
            <b-col class="align-self-center">
                <strong>Customers</strong>
            </b-col>
        </b-row>
        <b-list-group>
            <b-list-group-item button @click="detail(customer.psid)" v-for="customer in data.customers" :key="customer.psid">{{ customer.name }}</b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        page_id: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_pages',
        ])
    },
    data() {
        return {
            data: {},
            timer: null,
        }
    },
    watch: {
        $route: {
            async handler () {
                this.interval()
                this.timer = window.setInterval(this.interval, 1 * 60 * 1000)
            },
            immediate: true
        }
    },
    methods: {
        async fetch () {
            const response = await this.$store.dispatch('page/index', this.page_id)
            if (this.isResponseError(response)) {
                return false
            }
            this.data = response.data
        },
        async sync() {
            const response = await this.$store.dispatch('page/syncCustomers', this.page_id)
            this.data.batch_sync_customers.push({})
        },
        async detail(psid) {
            this.$router.push('/pages/' + this.page_id + '/customers/' + psid)
        },
        async interval () {
            this.fetch()
        },
    },
    mounted () {
    },
    destroyed () {
      clearInterval(this.timer)
    },
}
</script>

<style>
.breadcrumb {
    background-color: transparent;
}
</style>
